function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import ShadowedContainer from '../../Containers/Shadowed';
import ProductHeader from './ProductHeader';
import SliderDetail from './SliderDetail';
import Slider from '../index';
import { keys, isNil, merge, head, indexOf, reduce, max } from 'ramda';

var ProductSlider = function (_Component) {
  _inherits(ProductSlider, _Component);

  function ProductSlider() {
    _classCallCheck(this, ProductSlider);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onSlide = _this.onSlide.bind(_this);
    return _this;
  }

  ProductSlider.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        insuredAmount = _props.insuredAmount,
        productPrices = _props.productPrices,
        value = _props.value;
    var selectedIndex = value;
    var prices = keys(productPrices);
    var newState = {};

    if (!isNil(selectedIndex)) {
      newState = {
        value: indexOf(selectedIndex, prices)
      };
    }

    this.setState(merge(newState, {
      value: insuredAmount * 100
    }));
  };

  ProductSlider.prototype.onSlide = function onSlide(value) {
    var _props2 = this.props,
        productPrices = _props2.productPrices,
        onToggle = _props2.onToggle,
        selected = _props2.selected;
    this.setState({
      value: value
    });
    var prices = keys(productPrices);

    if (value / 100 < head(prices) && selected) {
      return onToggle(false);
    }

    var selectedPriceIndex = indexOf((value / 100).toString(), prices) + 1;

    if (value / 100 >= head(prices) && !selected) {
      return onToggle(true);
    }

    if (value / 100 >= head(prices)) {
      return this.props.onSlide(selectedPriceIndex);
    }

    return null;
  };

  ProductSlider.prototype.render = function render() {
    var _props3 = this.props,
        title = _props3.title,
        tooltip = _props3.tooltip,
        productPrices = _props3.productPrices,
        notSelectedText = _props3.notSelectedText,
        priceSuffix = _props3.priceSuffix;
    var prices = keys(productPrices).map(function (price) {
      return parseInt(price, 10);
    });
    var max = reduce(max, head(prices), prices) * 100;
    var step = (prices[1] - prices[0]) * 100 || 1;
    var min = head(prices) * 100;
    var selected = this.state.value < min ? false : this.props.selected;

    var _ref = selected === true ? this.state : {
      value: 0
    },
        value = _ref.value;

    return React.createElement(ShadowedContainer, null, React.createElement(ProductHeader, {
      title: title,
      price: value,
      selected: selected,
      notSelectedText: notSelectedText,
      priceSuffix: priceSuffix
    }), React.createElement(Slider, {
      init: min,
      min: min - step,
      step: step,
      max: max,
      tooltip: false,
      value: value,
      onChange: this.onSlide
    }), React.createElement('span', {
      className: 'space-below'
    }), React.createElement(SliderDetail, {
      min: min,
      max: max
    }), React.createElement(SliderDetail, {
      tooltip: tooltip
    }));
  };

  return ProductSlider;
}(Component);

export default ProductSlider;